import React from 'react'
import { Field } from 'redux-form';
import { BooleanInput, LongTextInput } from 'react-admin';

type Props = {
  baseName: string
};

const ImageUrlSettings = (props: Props) => (
  <div style={{ paddingTop: 20 }}>
    <Field name={`${props.baseName}.use_image_url`} source={`${props.baseName}.use_image_url`} component={BooleanInput} label="Use Image URL" />
    <Field name={`${props.baseName}.image_url`} source={`${props.baseName}.image_url`} component={LongTextInput} label="Image URL" />
  </div>
);

export default ImageUrlSettings;



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Site/Partials/ImageUrlSettings.tsx